const Component = () => import('./HouseholdMeals');

export { Component };
